/**
 * Colors_T33.jsx — Template 33 "Sky & Sea" Design
 * Palette: Sky Blue · Deep Navy · Coral Rose · Emerald Green
 */

export const mapB2CTenantToLanding = (tenantData) => {
  const theme  = tenantData?.theme  || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero   = tenantData?.hero   || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
    logoUrl:     tenantData?.branding?.logoUrl    || '/assets/images/logo.png',
    companyName:     tenantData?.branding?.companyName  || 'Travel Agency',
    brandName:       tenantData?.branding?.brandName    || 'Travel Agency',
    email:       tenantData?.branding?.email      || 'support@agency.com',
    phones:      Array.isArray(tenantData?.branding?.phones)
                   ? tenantData?.branding?.phones[0]
                   : tenantData?.branding?.phones  || '9128341203',
    whatsapp:    tenantData?.branding?.whatsapp   || '9128341203',
    socials:     tenantData?.branding?.socials    || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    topBarBg:   topBar.bgColor   || theme.themeColor1 || theme.themecolor1,
    topBarText: topBar.textColor || '#FFFFFF',

    headerBg:   header.bgColor   || '#FFFFFF',
    headerText: header.textColor || '#0C2340',

    footerBg:   footer.bgColor   || '#0C2340',
    footerText: footer.textColor || '#94A3B8',

    heroData: {
      flights: {
        title:     hero.flights?.title     || 'Your Adventure Starts Here',
        subTitle:  hero.flights?.subTitle  || 'Compare fares across 500+ airlines and fly smarter every time.',
        textColor: hero.flights?.textColor || '#FFFFFF',
        bgImage:   hero.flights?.bgImage   || 'https://images.unsplash.com/photo-1529074963764-98f45c47344b?q=80&w=1600',
      },
      hotels: {
        title:     hero.hotels?.title     || 'Sleep Where You Belong.',
        subTitle:  hero.hotels?.subTitle  || 'From city boutiques to overwater villas — every stay curated for you.',
        textColor: hero.hotels?.textColor || '#FFFFFF',
        bgImage:   hero.hotels?.bgImage   || 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?q=80&w=1600',
      },
      holidays: {
        title:     hero.holidays?.title     || 'Holidays Without Limits.',
        subTitle:  hero.holidays?.subTitle  || 'All-inclusive packages crafted for curious souls and bold explorers.',
        textColor: hero.holidays?.textColor || '#FFFFFF',
        bgImage:   hero.holidays?.bgImage   || 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=1600',
      },
      sightseeing: {
        title:     hero.sightseeing?.title     || 'See the World, Feel It.',
        subTitle:  hero.sightseeing?.subTitle  || 'Hand-picked tours, thrilling activities & bucket-list experiences.',
        textColor: hero.sightseeing?.textColor || '#FFFFFF',
        bgImage:   hero.sightseeing?.bgImage   || 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?q=80&w=1600',
      },
    },
  };
};

export const getB2CColors_T33 = (landingData) => {
  const c1 = landingData.themeColor1 || '#0284C7'; // Sky blue
  return {
    theme1: c1,
    theme2: landingData.footerBg    || '#0C2340', // Deep ocean navy
    theme3: landingData.headerBg    || '#FFFFFF',
    theme4: landingData.themeColor4 || '#F0F9FF', // Ice blue surface
    theme5: landingData.themeColor5 || '#FFFFFF',

    headerText: landingData.headerText || '#0C2340',
    footerText: landingData.footerText || '#94A3B8',
    topBarBg:   landingData.topBarBg   || '#0C2340',
    topBarText: landingData.topBarText || '#FFFFFF',

    coral:   '#F43F5E',  // Coral rose accent
    emerald: '#10B981',  // Emerald green accent
    amber:   '#F59E0B',
    violet:  '#7C3AED',
  };
};
